import React from "react";
import { useSettings } from "@/hooks/useSettings";
import { AlertTriangle } from "lucide-react";

export default function AnnouncementBar() {
  const { data } = useSettings();
  if (!data?.announcementActive || !data?.announcement) return null;
  const text = data.announcement;
  return (
    <div className="bg-danger text-white overflow-hidden border-b-3 border-black" data-testid="announcement-bar">
      <div className="flex whitespace-nowrap animate-marquee py-1.5 font-mono text-xs font-bold uppercase tracking-wider">
        {[0, 1].map((k) => (
          <span key={k} className="flex items-center">
            {Array.from({ length: 6 }).map((_, i) => (
              <span key={i} className="flex items-center mx-6">
                <AlertTriangle className="w-3.5 h-3.5 mr-2" /> {text}
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
